import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import ConfigIcon from "assets/icon/configurationIcon.svg";
import ConfigIconHover from "assets/icon/SettingsHover.svg";
import HoverImage from "react-hover-image/build";
import CEContractConfig from "components/CEContractConfig";
import { isBoolean } from "lodash";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import { toast } from "react-toastify";
import { GlobalComments } from "components/Comments";
import Drawer from "components/Drawer";
import { ModuleAccess } from "utils/moduleaccess";
import ErrorBoundary from "components/ErrorBoundary";
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";
import { cellRendererCheck } from "utils/columns";

let rowForEdit = {};

const ConfigurationTable = ({
  module,
  data,
  onExport,
  filters,
  totalSize,
  onPageChange,
  coveredEntityID,
  refetch,
  tenantID,
  setLoading,
  onSearchColumnFilters,
  reset,
  toggleSider,
  resetFlag,
  SetResetFlag,
  collapseSider,
  orgId,
}) => {
  const API = useAxios();
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });

  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
  };


  const [isOpenContract, setOpenContract] = useState(false);
  const [contractId, setCEContract] = useState(-1);
  const [claimStatusLKP, setClaimStatusLKP] = useState([]);
  const [commentDrawer, setCommentDrawer] = useState(false);
  const [commentRowData, setCommentRowData] = useState({});
  const [selectedPharmacyName, setSelectedPharmacyName] = useState("");
  const [hasExportPermission, setHasExportPermission] = useState(false);
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
  }, [data]);

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    fetchClaimStatusLKP();
    setHasExportPermission(ModuleAccess("CON", "EXP"));
  }, []);

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setState({
      tableData: [],
      backUpData: [],
    });
    rowForEdit = {};
  }, [reset]);

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  const fetchClaimStatusLKP = async () => {
    try {
      const { data } = await API.get("Config/TypeStatus/ClaimStatusList");
      if (data) {
        setClaimStatusLKP(data);
        setState({ loading: false });
      } else {
        setState({ loading: false });
      }
    } catch (error) {
      setState({ loading: false });
    }
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      cellRenderer: (row) => cellRenderButton(row),
      action: true,
    },
    {
      dataField: "pharmacyName",
      text: "Pharmacy Name",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row, col) => formatter(row, col),
      edit: false,
    },
    {
      dataField: "npi",
      text: "Pharmacy NPI",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "checkbox"),
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
      edit: true,
    },
    {
      dataField: "ThirdPartyAdminName",
      text: "Third Party Admin",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      //cellRenderer: (row, col) => formatter(row, col, "textarea"),
      cellRenderer: (row) => cellRendererCheck(row.tpaName),
    },
  ];

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };
  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
    setCommentRowData(rowData);
  };

  const handleFilterCancel = () => {

    refetch(true);
    //   initialFilters.filters = [];
    //   setState({
    //     filters: initialFilters.filters,
    //   });
    //   onSearchColumnFilters(initialFilters, true);
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      // const filter = { ...state.filters, filters: { ...state.filters.filters, ...colFilter }, currentPage: 1 };
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter, false);
      setState({
        filters: filter,
      });
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };


  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
    //return (module && module.actions.indexOf(code) != -1)
  };

  const cellRenderButton = (row) => {
    if (row.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={saveUpdateRow}
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(row, false)}
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    } else if (hasPermission("ED")) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(row)}
          >
            <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editConfiguration(row)}
          >
            <HoverImage
              key="ConfigIcon"
              src={ConfigIcon}
              hoverSrc={ConfigIconHover}
              alt=""
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editConfiguration(row)}
          >
            <HoverImage
              key="ConfigIcon"
              src={ConfigIcon}
              hoverSrc={ConfigIconHover}
              alt=""
            />
          </Button>
        </div>
      );
    }
  };

  const editConfiguration = (row) => {
    setOpenContract(!isOpenContract);
    setCEContract(row.contractID);
    setSelectedPharmacyName(row.pharmacyName);
  };

  const toggleConfigModal = (hasRefresh) => {
    if (isBoolean(hasRefresh) && hasRefresh) {
      refetch();
    }
    setOpenContract(!isOpenContract);
  };

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.contractID === rowData?.contractID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setState({
      backUpData: tempData,
      tableData: tempData,
    });
  };

  const saveUpdateRow = async () => {
    setLoading(true);
    const payload = { ...rowForEdit };
    delete payload.isEdit;
    try {
      const result = await API.post(
        `Config/ceconfig/Update/${coveredEntityID}`,
        payload
      );
      if (result) {
        if (result.data.error) {
          toast.error(result.data.message);
        } else {
          toast.success("Item updated successfully");
          refetch();
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (data.length == 0 && isOpenContract == true) {
      toggleConfigModal()
    }
  }, [data])

  const { filters: colFilter, backUpData } = state;
  return (
    <div>
      <div className="d-flex justify-content-between mt-3">
        <div className="">
          <h5 className="f-16 text-primary font-weight-700 m-0">
            Configurations Count ({totalSize})
          </h5>
        </div>
        <div>
          <Row>
            <Col xs="auto p-0">
              <div
                className=""
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={backUpData.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="configuration-table"
          fixedColumn
          data={backUpData}
          columns={columns}
          onPageSizeChange={onPageSizeChange}
          pageSize={colFilter.pageSize}
          filters={filters}
          onExport={onExport}
          hasPagination
          onSearchColumnFilters={handleSearchColumnFilters}
          onPageChange={onHandlePageChange}
          onFilterCancel={handleFilterCancel}
          currentPage={colFilter.currentPage}
          totalRecords={totalSize}
          handleSort={onHandleSort}
          hasExportPermission={hasExportPermission}
          showtoggle={true}
          collapseSider={collapseSider}
          resetFlag={resetFlag}
          SetResetFlag={SetResetFlag}
          toggleSider={toggleSider}
        />
        <Drawer
          size="lg"
          direction="end"
          isOpen={isOpenContract}
          toggle={editConfiguration}
          title={"Edit Pharmacy Configuration "}
        >
          <ErrorBoundary>
            <CEContractConfig
              contractId={contractId}
              toggle={toggleConfigModal}
              claimStatusLKP={claimStatusLKP}
              pharmacyName={selectedPharmacyName}
              module={module}
            />
          </ErrorBoundary>
        </Drawer>
        {/* <Modal
                isOpen={isOpenContract}
                toggle={editConfiguration}
                size='xl'
                className='xl'

            >
                <ModalHeader toggle={editConfiguration}>
                    
                </ModalHeader>
                <ModalBody>
                    <CEContractConfig contractId={contractId} toggle={toggleConfigModal} claimStatusLKP={claimStatusLKP} pharmacyName={selectedPharmacyName} module={module} />
                </ModalBody>
            </Modal> */}
        <Drawer
          direction="end"
          title="All Comments"
          isOpen={commentDrawer}
          toggle={toggleCommentDrawer}
        >
          <GlobalComments
            tenantID={tenantID}
            row={commentRowData}
            coveredEntityID={coveredEntityID}
            commentID={commentRowData?.commentID}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default ConfigurationTable;
